import { ISubdivisionShort, ITreeDataNode } from 'common/models';
import { DEFAULT_VALUE_0 } from 'common/config';
import { generateTreeNodeKeyAndSort } from 'common/helpers';
import { ISubdivision, ISubdivisionItem } from 'entities/Subdivision/Subdivision.models';

export const getSubdivisionOptions = (list: ISubdivisionShort[]) => {
  return list
    .map((subdivision) => ({ label: subdivision.name, value: subdivision.id }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const calculateSubdivisionBalance = (subdivision: ISubdivision | null) => {
  return subdivision?.limit ? subdivision.limit - (subdivision.spentLimit || DEFAULT_VALUE_0) : null;
};

export const mapSubdivisionListToSubdivisionOptions = (list: ISubdivisionItem[]) => {
  return list
    .map((subdivision) => ({ label: subdivision.name, value: subdivision.id }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const findSubdivisionChildrenIds = (id: number, subdivisionList: ISubdivisionItem[]): number[] => {
  const parentToChildrenMap = new Map<number, number[]>();

  for (const subdivision of subdivisionList) {
    if (subdivision.parentId) {
      const children = parentToChildrenMap.get(subdivision.parentId) || [];
      children.push(subdivision.id);
      parentToChildrenMap.set(subdivision.parentId, children);
    }
  }

  const result: number[] = [];
  const stack: number[] = [id];

  while (stack.length) {
    const currentId = stack.pop() as number;
    const children = parentToChildrenMap.get(currentId);

    result.push(currentId);

    if (children) {
      stack.push(...children);
    }
  }

  return result;
};

export const buildSubdivisionTree = (subdivisions: ISubdivisionItem[]): ITreeDataNode[] => {
  const map = new Map<number, ITreeDataNode>();

  subdivisions.forEach((item) => {
    map.set(item.id, {
      key: String(item.id),
      title: item.name,
      children: [],
    });
  });

  const tree: ITreeDataNode[] = [];

  subdivisions.forEach((item) => {
    const node = map.get(item.id);

    if (node && item.parentId && map.has(item.parentId)) {
      const parent = map.get(item.parentId);

      if (parent) {
        parent.children = parent.children || [];
        parent.children.push(node);
      }
    } else {
      if (node) {
        tree.push(node);
      }
    }
  });

  generateTreeNodeKeyAndSort(tree);

  return tree;
};
